import { Location } from 'vue-router'
import { UsersViewPublication as Data } from '@/typings/api/Publication'

import { dateFormatter } from '@/helpers/dateFormatter'
import { PUBLICATIONS_ROUTES as ROUTES } from '@/views/Publications/utils'
import { Topic } from '@/typings/api/Topic'


const DATE_FORMAT = 'DD.MM.YYYY HH:mm'

const getViewRoute = (data: Data): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

const getTopicNames = (data: Array<Topic>) => data?.map(({ name }) => name).join(', ')

export const TABLE_ACTIONS = Object.freeze([
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
  },
  {
    text: 'Топики',
    value: 'topics',
    sortable: false,
    field: (value: Data['topics']) => getTopicNames(value),
  },
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: getViewRoute,
  },
  {
    text: 'Дата начала публикации',
    value: 'start_at',
    sortable: true,
    width: 136,
    field: (value: Data['start_at']) => dateFormatter(value, DATE_FORMAT),
  },
  {
    text: 'Дата окончания публикации',
    value: 'end_at',
    sortable: true,
    width: 136,
    field: (value: Data['end_at']) => dateFormatter(value, DATE_FORMAT),
  },
])
